import React, { Component } from 'react';

class IconTicketBoxStyle extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="93"
        height="74"
        fill="none"
        viewBox="0 0 123 104"
      >
        <path
          fill={this.props.iconFill}
          fillRule="evenodd"
          d="M118.963 104H10c-5.523 0-10-4.477-10-10V13.378C12.574 4.929 27.71 0 44 0c43.63 0 79 35.37 79 79a78.92 78.92 0 01-4.037 25z"
          clipRule="evenodd"
        ></path>
      </svg>
    );
  }
}

export default IconTicketBoxStyle;